import * as React from "react";
import { useErrorLog } from "../../helpers/error-provider/use-log.mjs";
const Heading = (props) => {
  const { element = "h1", level, children, className, id } = props;
  const { log } = useErrorLog();
  const isLevelValid = (l) => {
    if (!l) {
      return false;
    }
    if (l > 6 || l < 1) {
      log("Level ".concat(l, " passed to Heading, which is incorrect. Rendering Heading with level 1 instead."));
      return false;
    }
    return true;
  };
  const HeadingTag = isLevelValid(level) ? "h".concat(level) : element;
  const BEM = () => {
    const classArray = ["heading"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(HeadingTag, { className: BEM(), id }, children);
};
export {
  Heading
};
